import { Outlet } from '@hub/router';
import { AppShell } from './AppShell';

export function PublicLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
